import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

import { MomentumRecordType } from 'features/momentum/config';

import { useUserId } from '../../../user/hooks/useUserId';

type UseMomentumQueryProps = {
  dateRange: {
    startDate: string;
    endDate: string;
  };
  options?: {
    enabled?: boolean;
  };
};

export const useMomentumQuery = ({
  dateRange,
  options = {},
}: UseMomentumQueryProps) => {
  const { request } = useQueryHTTPRequest();
  const userId = useUserId();

  return useQuery(
    [queryKeys.momentum, dateRange.startDate, dateRange.endDate],
    async ({ signal }) =>
      await request({
        url: `/api/momentum?from_date=${dateRange.startDate}&to_date=${dateRange.endDate}&target_user_id=${userId}`,
        signal,
      }),
    {
      select: (data: {
        momentumScores: {
          date: string;
          score: number;
          receivedEarlyBonus: boolean;
          completionRate: number;
        }[];
      }) => {
        // Transform API response to match MomentumRecordType
        return data.momentumScores.map((item) => ({
          date: item.date,
          score: item.score,
          completionRate: item.completionRate,
        })) as MomentumRecordType[];
      },
      ...options,
    }
  );
};
